import React from 'react';
import { observer } from 'mobx-react';
import { Link } from 'react-router';

// Translations
import translate from '../Translate.js';

// Dependencies
import Dropdown, { DropdownTrigger, DropdownContent } from 'react-simple-dropdown';

const SplitButton = observer(class SplitButton extends React.Component {
  constructor() {
    super();
    this.toggleOptions = this.toggleOptions.bind(this);
  }

  componentWillMount() {
    this.state = {
      showing: false
    };
  }

  toggleOptions(e) {
    this.setState({
      showing: !this.state.showing
    });
  }

  render() {
    const { icon, options, text, to, translation } = this.props;

    return (
      <div
        className={`split-btn ${this.props.className} ${!this.props.options ? 'split-btn--empty' : ''}`}
      >
        <Link
          className="split-btn__link cover"
          to={to}
        >
          {text}
        </Link>

        <span
          className="split-btn__text"
          aria-hidden="true"
        >
          {icon}
          {text}
        </span>

        {this.props.options &&
          <Dropdown
            ref="splitButton"
            onShow={this.toggleOptions}
            onHide={this.toggleOptions}
          >
            <DropdownTrigger
              className="split-btn__trigger"
            >
              <span className="meta">{translation.dropdown}</span>
            </DropdownTrigger>

            <DropdownContent>
              <ul className="dropdown__menu">
                {options.map(
                  (key, i) =>
                  <li key={i}>
                    <Link className="dropdown__item split-btn__option" to={key.to}>
                      {key.title}
                    </Link>
                  </li>
                )}
              </ul>
            </DropdownContent>
          </Dropdown>
        }
      </div>
    )
  }
})

export default translate('SplitButton')(SplitButton);



// WEBPACK FOOTER //
// ./src/app/components/Common/SplitButton.js